interface IPlayIcon {
  className?: string
}

const PlayIcon = ({ className }: IPlayIcon) => (
  <svg
    className={className}
    fill="none"
    height="12"
    viewBox="0 0 9 12"
    width="9"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 6L4.64275e-07 11.1962L9.18537e-07 0.803847L9 6Z"
      fill="black"
    />
  </svg>
)

export default PlayIcon
